/**
 * Feature switches read from the build-time environment.
 *
 * Each flag has a safe default so the app runs correctly with no environment
 * configuration at all — an unset variable never breaks a build or a page.
 */

/**
 * Self-service registration.
 *
 * Off unless explicitly enabled, so an environment that forgets the variable
 * keeps signup closed rather than exposing it by accident. Accounts are created
 * from the admin dashboard instead. Set VITE_SIGNUP_ENABLED=true to restore the
 * public signup page and its links.
 */
export const SIGNUP_ENABLED = import.meta.env.VITE_SIGNUP_ENABLED === 'true';
